import { BasicGrid, Button } from '@104ha/base-ui';
import React from 'react';

const Btn: React.FC<{ children: React.ReactNode; onClick?: () => any }> = ({ children, ...props }) => (
	<Button.Normal theme="primary" className="btn-block" {...props}>
		{children}
	</Button.Normal>
);

export class Grid extends BasicGrid<{}, { confirm: any }> {
	static defaultProps = {
		...BasicGrid.defaultProps,
		api: '/api/manage/token/find',
		colWidths: [140, 40, '*', '*', 100, 200],
		fetch: false,
	};

	renderGridHeader() {
		const { TH } = this;
		return (
			<tr>
				<th></th>
				<TH.seq />
				<TH.sortable sortKey="userAccount">API登入帳號</TH.sortable>
				<TH.sortable sortKey="userName">帳號名稱</TH.sortable>
				<TH.sortable sortKey="authMode">串接方式</TH.sortable>
				<TH.sortable sortKey="refreshToken">Token(金鑰)</TH.sortable>
				<TH.sortable sortKey="ip">登入IP</TH.sortable>
				<TH.sortable sortKey="expireDatetime">Token到期時間</TH.sortable>
			</tr>
		);
	}

	deleteHandler = () => {
		new _Ajax({
			url: '/api/manage/token/revoke',
			data: {
				id: this.state.confirm.id,
			},
			successMsg: '停用token完成!',
			errMsg: '停用token失敗',
			onSuccess: () => {
				this.reload();
			},
		}).send();
	};

	renderGridBody(data: any, idx: number) {
		const { TD } = this;
		const { userAccount, userName, authMode, refreshToken, expireDatetime, ip } = data;

		return (
			<>
				<td>
					<Btn
						onClick={() => {
							this.setState({
								confirm: {
									id: data.id,
									msg: '確定要停用嗎',
								},
							});
						}}
					>
						停用
					</Btn>
				</td>
				<TD.seq idx={idx} />
				<td>{userAccount}</td>
				<td>{userName}</td>
				<td>{authMode === 1 ? 'Token串接模式' : 'API 金鑰模式'}</td>
				<td>{refreshToken}</td>
				<td>{ip}</td>
				<td>{expireDatetime}</td>
			</>
		);
	}
}
